<template>
  <div class="c-general-reports">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title class="d-block px-5">
              <v-row>
                <v-col cols="12" sm="auto">Filter</v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    dense
                    hide-details
                    label="Group by"
                    item-text="title"
                    item-value="val"
                    multiple
                    :items="groupByItems"
                    v-model="groupBy"
                  >
                    <template v-slot:prepend-inner v-if="groupBy">
                      <v-btn icon x-small @click.prevent="groupBy = null">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-autocomplete
                  label="Department"
                  :items="departments"
                  v-model="filter.Dep_ID"
                  item-text="Dep_Name"
                  item-value="Dep_ID"
                  multiple
                  dense
                  hide-details
                  :disable-lookup="true"
                  clearable
                  @click:clear="clearDepartmentList()"
                  :search-input.sync="searchDepartment"
                  >
                    <template v-slot:prepend-item>
                      <div class="px-4">
                        <v-checkbox
                          dense
                          v-model="selectAllDepartments"
                          @change="selectAll"
                          label="Select all"
                        ></v-checkbox>
                      </div>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.Dep_Name }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >
                        (+{{ filter.Dep_ID.length - 1 }} others)
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-text-field
                    dense
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <!-- Date picker -->
                <v-col>
                  <RangeDatePickerMenu
                    v-model="filter.DateRange"
                    showButtons
                  />
                </v-col>
                <!-- /Date picker -->
                <!-- Projects list -->
                <v-col>
                  <v-autocomplete
                    dense
                    hide-details
                    :items="projects"
                    item-value="Project_ID"
                    item-text="Description"
                    label="Project"
                    v-model="filter.Project_ID"
                    multiple
                    :disable-lookup="true"
                    clearable
                    @click:clear="clearProjectList()"
                    :search-input.sync="searchProject"
                  >
                    <template v-slot:prepend-item>
                      <div class="px-4">
                        <v-checkbox
                          dense
                          v-model="selectAllProjects"
                          @change="selectAll"
                          label="Select all"
                        ></v-checkbox>
                      </div>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.Description }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >
                        (+{{ filter.Project_ID.length - 1 }} others)
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- /Projects list -->
                <!-- Clients list -->
                <v-col>
                  <v-autocomplete
                    dense
                    hide-details
                    :items="clients"
                    item-value="Client_ID"
                    item-text="Name"
                    label="Client"
                    multiple
                    :disable-lookup="true"
                    v-model="filter.Client_ID"
                    clearable
                    @click:clear="clearClientList()"
                    :search-input.sync="searchClient"
                  >
                    <template v-slot:prepend-item>
                      <div class="px-4">
                        <v-checkbox
                          dense
                          v-model="selectAllClients"
                          @change="selectAll"
                          label="Select all"
                        ></v-checkbox>
                      </div>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.Name }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >
                        (+{{ filter.Client_ID.length - 1 }} others)
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- /Clients list -->
                <!-- Employee list -->
                <v-col>
                  <v-autocomplete
                    dense
                    hide-details
                    :items="employee"
                    item-value="employee_id"
                    item-text="full_name"
                    label="Employee"
                    multiple
                    :disable-lookup="true"
                    v-model="filter.Employee_ID"
                    clearable
                    @click:clear="clearEmployeeList()"
                    :search-input.sync="searchEmployee"
                  >
                    <template v-slot:prepend-item>
                      <div class="px-4">
                        <v-checkbox
                          dense
                          v-model="selectAllEmployee"
                          @change="selectAll"
                          label="Select all"
                        ></v-checkbox>
                      </div>
                      <v-divider></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.full_name }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >
                        (+{{ filter.Employee_ID.length - 1 }} others)
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- /Employee list -->
                <v-col cols="auto">
                  <TableColumnConfigMenu
                    :default-headers="defaultHeaders"
                    :column-config="columnConfig"
                    @save="onColumnConfigSave"
                  />
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="primary"
                    small
                    :outlined="reports.length > 0"
                    :disabled="!canGetReports || !isChangedQueryParams"
                    @click.prevent="getReports"
                  >Show reports</v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <GeneralReportsTable
                :key="updateKey + '_' + countOfGroups"
                :headers="resolvedHeaders"
                :items="reports"
                :group-by="groupBy"
                :pagination="pagination"
                :search="search"
                @groupChange="onGroupChange"
                @removeReport="removeReport"
                @updateReport="updateReport"
                v-if="showReportsTable"
              />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer class="d-none d-sm-block"></v-spacer>
              <v-col cols="auto" class="text-caption text-no-wrap">
                <span class="d-none d-sm-inline-block mr-3">Rows per page:</span>
                <v-select
                  class="d-inline-block"
                  style="max-width: 70px;"
                  v-model="itemsPerPage"
                  dense
                  hide-details
                  :items="paginationValues"
                  @change="changeRowsPerPage"
                ></v-select>
                <span class="mx-3"
                  style="user-select: none"
                >
                  {{  pagination.from + 1 }}-{{ pagination.to }} of {{ countOfGroups > 1 ? countOfGroups : reports.length }}
                </span>
                <v-btn icon small
                  :disabled="pagination.from === 0"
                  @click="prevPage"
                >
                  <v-icon>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-btn icon small class="ml-3"
                  :disabled="pagination.to >= (countOfGroups > 1 ? countOfGroups : reports.length)"
                  @click="nextPage"
                >
                  <v-icon>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { tableColumnConfigMixin } from '@/mixins/tableColumnConfigMixin'

export default {
  name: 'GeneralReports',
  mixins: [tableColumnConfigMixin],
  components: {
    GeneralReportsTable: () => import('@/components/general_reports/GeneralReportsTable.vue'),
    RangeDatePickerMenu: () => import('@/components/global/RangeDatePickerMenu.vue'),
    TableColumnConfigMenu: () => import('@/components/global/TableColumnConfigMenu.vue')
  },
  data () {
    return {
      updateKey: 0,
      search: '',
      searchClient: '',
      searchEmployee: '',
      searchProject: '',
      searchDepartment: '',
      datesMenu: false,
      invoiceDurMenus: {},
      paidDurMenus: {},
      reportedDurMenus: {},
      startDateMenus: {},
      currentEmployee: null,
      groupBy: null,
      tempDescription: '',
      showDescriptionDialog: false,
      currentReport: null,
      selectAllProjects: false,
      selectAllClients: false,
      selectAllEmployee: false,
      selectAllDepartments: false,
      sortBy: undefined,
      sortDesc: undefined,
      selectedItems: {
        Date_From: null,
        Date_To: null,
        Client_IDs: null,
        Project_IDs: null,
        Employee_IDs: null,
        Department_IDs: null
      },
      countOfGroups: 1,
      pagination: {
        from: 0,
        to: 100
      },
      itemsPerPage: 100,
      totals: {
        Real_Dur: 0,
        Report_Dur: 0,
        Invoice_Dur: 0
      },
      groupByItems: [
        {
          title: 'Project',
          val: 'Project_Name'
        },
        {
          title: 'Project Group',
          val: 'Project_Group'
        },
        {
          title: 'Task',
          val: 'Task_Name'
        },
        {
          title: 'Client',
          val: 'Client_Name'
        },
        {
          title: 'Start date',
          val: 'Start_Date'
        },
        {
          title: 'Month',
          val: 'Month'
        },
        {
          title: 'Year',
          val: 'Year'
        },
        {
          title: 'Activity',
          val: 'Activity_Type_Description'
        },
        {
          title: 'Employee',
          val: 'Employee_FullName'
        },
        {
          title: 'Department',
          val: 'Department'
        }
      ],
      filter: {
        Employee_ID: [],
        DateRange: [],
        Project_ID: [],
        Client_ID: [],
        Dep_ID: []
      },
      reports: [],
      showReportsTable: true,
      firstDayOfTheMonth: null,
      lastDayOfTheMonth: null,
      tableColumnConfigKey: 'general_reports',
      columnConfig: null
    }
  },
  computed: {
    paginationValues () {
      const res = [100, 200, 300, 400, 500]
      if (this.reports.length > 0 && this.reports.length < 1000) res.push('All')
      return res
    },
    isChangedQueryParams () {
      if (this.selectedItems.Date_From !== this.filter.DateRange[0]) return true
      if (this.selectedItems.Date_To !== this.filter.DateRange[1]) return true
      if (this.selectedItems.Client_IDs !== this.filter.Client_ID) return true
      if (this.selectedItems.Project_IDs !== this.filter.Project_ID) return true
      if (this.selectedItems.Employee_IDs !== this.filter.Employee_ID) return true
      if (this.selectedItems.Department_IDs !== this.filter.Dep_ID) return true
      return false
    },
    activityTypes () {
      return this.$store.getters.getActivityTypes
    },
    canGetReports () {
      return this.filter.DateRange.length === 2
    },
    user () {
      return this.$store.getters.getUser
    },
    projects () {
      const r = new RegExp(this.searchProject, 'gi')
      if (this.searchProject) {
        return this.$store.getters.getProjects.filter(item => {
          r.lastIndex = 0
          return r.test(item.Description) && !item.Is_Deleted
        })
      } else {
        return this.$store.getters.getProjects.filter(item => {
          return !item.Is_Deleted
        })
      }
    },
    clients () {
      const r = new RegExp(this.searchClient, 'gi')
      if (this.searchClient) {
        return this.$store.getters.getClients.filter(item => {
          r.lastIndex = 0
          return r.test(item.Name)
        })
      } else {
        return this.$store.getters.getClients
      }
    },
    employee () {
      const r = new RegExp(this.searchEmployee, 'gi')
      if (this.searchEmployee) {
        return this.$store.getters.getEmployee.filter(item => {
          r.lastIndex = 0
          return r.test(item.full_name)
        })
      } else {
        return this.$store.getters.getEmployee
      }
    },
    departments () {
      const r = new RegExp(this.searchDepartment, 'gi')
      if (this.searchDepartment) {
        return this.$store.getters.getDepartments.filter(item => {
          r.lastIndex = 0
          return r.test(item.Dep_Name)
        })
      } else {
        return this.$store.getters.getDepartments
      }
    },
    filteredHeaders () {
      if (!this.groupBy || !this.groupBy.length) return this.resolvedHeaders
      return this.resolvedHeaders.filter(h => this.groupBy.indexOf(h.value) === -1)
    },
    resolvedHeaders () {
      return this.applyTableColumnConfig(this.defaultHeaders)
    },
    defaultHeaders () {
      return [
        {
          text: 'Employee',
          value: 'Employee_FullName',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Project',
          value: 'Project_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        },
        {
          text: 'Project Group',
          value: 'Project_Group',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        },
        {
          text: 'Department',
          value: 'Department',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        },
        {
          text: 'Client',
          value: 'Client_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        },
        {
          text: 'Task',
          value: 'Task_Name',
          divider: true,
          class: 'px-2',
          cellClass: 'px-2'
        },
        {
          text: 'Start Date',
          value: 'Start_Date',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          width: '160'
        },
        {
          text: 'Reported Duration',
          value: 'Real_Dur',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Paid Duration',
          value: 'Report_Dur',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Invoice Duration',
          value: 'Invoice_Dur',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Activity Type',
          value: 'Activity_Type_Description',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Description',
          value: 'Description',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        }
      ]
    }
  },
  mounted () {
    this.loadTableColumnConfig()
    if (!this.employee.length) {
      this.getEmployee()
    }
    if (!this.clients.length) {
      this.getClients()
    }
    if (!this.projects.length) {
      this.getProjects()
    }
    if (!this.departments.length) {
      this.getDepartments()
    }
    if (this.$route.params.Project_ID) {
      this.filter.Project_ID = [this.$route.params.Project_ID]
      this.continueGettingProjectsFromOtherPage()
    } else if (this.$route.params.Client_ID) {
      this.filter.Client_ID = [this.$route.params.Client_ID]
      this.continueGettingProjectsFromOtherPage()
    } else if (this.$route.params.Employee_ID) {
      this.filter.Employee_ID = [this.$route.params.Employee_ID]
      this.continueGettingProjectsFromOtherPage()
    }
  },
  methods: {
    removeReport (reportID) {
      const i = this.reports.findIndex(item => item.Reporting_ID === reportID)
      if (i > -1) {
        this.reports.splice(i, 1)
      }
    },
    onGroupChange (e) {
      this.countOfGroups = e
      this.changeRowsPerPage()
    },
    changeRowsPerPage () {
      const total = this.countOfGroups > 1 ? this.countOfGroups : this.reports.length
      if (this.itemsPerPage !== 'All') {
        this.pagination.from = 0
        this.pagination.to = this.itemsPerPage
      } else {
        this.pagination.from = 0
        this.pagination.to = total
      }
    },
    prevPage () {
      this.pagination.from -= this.itemsPerPage
      this.pagination.to = this.pagination.from + this.itemsPerPage
    },
    nextPage () {
      const total = this.countOfGroups > 1 ? this.countOfGroups : this.reports.length
      this.pagination.from += this.itemsPerPage
      this.pagination.to = (this.pagination.to + this.itemsPerPage) >= total
        ? total
        : this.pagination.to + this.itemsPerPage
    },
    currentSortBy (e) {
      this.sortBy = e.sortBy[0]
      this.sortDesc = e.sortDesc[0]
    },
    selectAll () {
      if (this.selectAllProjects) {
        this.filter.Project_ID = []
        this.projects.forEach(item => {
          this.filter.Project_ID.push(item.Project_ID)
        })
      } else {
        this.filter.Project_ID = []
      }
      if (this.selectAllClients) {
        this.filter.Client_ID = []
        this.clients.forEach(item => {
          this.filter.Client_ID.push(item.Client_ID)
        })
      } else {
        this.filter.Client_ID = []
      }
      if (this.selectAllEmployee) {
        this.filter.Employee_ID = []
        this.employee.forEach(item => {
          this.filter.Employee_ID.push(item.employee_id)
        })
      } else {
        this.filter.Employee_ID = []
      }
      if (this.selectAllDepartments) {
        this.filter.Dep_ID = []
        this.departments.forEach(item => {
          this.filter.Dep_ID.push(item.Dep_ID)
        })
      } else {
        this.filter.Dep_ID = []
      }
    },
    allowedMinutes (m) {
      return m === 30 || m === 0
    },
    openDescriptionDialog (item) {
      this.currentReport = item
      this.tempDescription = item.Description
      this.showDescriptionDialog = true
    },
    saveDescription () {
      this.currentReport.Description = this.tempDescription
      this.updateReport(this.currentReport)
      this.showDescriptionDialog = false
    },
    updateReport (report) {
      const i = this.reports.findIndex(item => item.Reporting_ID === report.Reporting_ID)
      if (i > -1) {
        this.$set(this.reports, i, report)
      }
    },
    updateDates (e) {
      const d1 = +(new Date(e[0]))
      const d2 = +(new Date(e[1]) || new Date(e[0]))
      if (d1 < d2) this.filter.DateRange = [e[0], e[1]]
      else if (d1 > d2) this.filter.DateRange = [e[1], e[0]]
      else this.filter.DateRange = [e[0], e[1]]
      if (d1 && d2) this.datesMenu = false
    },
    getEmployee () {
      this.axios.get('/api/employeelist', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setEmployeeList', { employeeList: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getClients () {
      this.axios.get('/api/clients', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setClients', { clients: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getProjects () {
      this.axios.get('/api/projects', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setProjects', { projects: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getDepartments () {
      this.axios.get('/api/department', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setDepartments', { departments: res.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    continueGettingProjectsFromOtherPage () {
      this.setFirstAndLastDaysOfTheMonth()
      this.filter.DateRange = [this.firstDayOfTheMonth, new Date().toISOString().slice(0, 10)]
      setTimeout(() => { this.getReports() })
    },
    fillReports (reports, start, end) {
      for (let i = start; i < end; i++) {
        if (reports[i]) {
          this.reports.push(reports[i])
          reports[i].Activity_Type = reports[i].Activity_Type ? reports[i].Activity_Type.toUpperCase() : reports[i].Activity_Type
        } else {
          break
        }
      }
      if (end < reports.length) setTimeout(() => this.fillReports(reports, end, end + 1000))
      else {
        this.$store.dispatch('showOverlay', { show: false })
        this.updateKey++
        this.showReportsTable = true
        return 0
      }
    },
    getReports () {
      this.$store.dispatch('showOverlay', { show: true })
      this.showReportsTable = false
      this.axios.get('/api/general_reports', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        },
        params: {
          Date_From: this.filter.DateRange[0],
          Date_To: this.filter.DateRange[1],
          Client_IDs: this.selectAllClients ? null : this.filter.Client_ID,
          Project_IDs: this.selectAllProjects ? null : this.filter.Project_ID,
          Employee_IDs: this.selectAllEmployee ? null : this.filter.Employee_ID,
          Department_IDs: this.selectAllDepartments ? null : this.filter.Dep_ID,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc
        }
      }).then(res => {
        this.$store.dispatch('showOverlay', { show: true })
        this.calculateTotals = false
        this.invoiceDurMenus = {}
        this.paidDurMenus = {}
        this.reportedDurMenus = {}
        this.startDateMenus = {}
        this.reports = []
        this.totals.Real_Dur = res.data[1][0].Total_Real_Dur
        this.totals.Report_Dur = res.data[1][0].Total_Paid_Dur
        this.totals.Invoice_Dur = res.data[1][0].Total_Invoice_Dur
        this.selectedItems.Date_From = this.filter.DateRange[0]
        this.selectedItems.Date_To = this.filter.DateRange[1]
        this.selectedItems.Client_IDs = this.filter.Client_ID
        this.selectedItems.Project_IDs = this.filter.Project_ID
        this.selectedItems.Employee_IDs = this.filter.Employee_ID
        this.selectedItems.Department_IDs = this.filter.Dep_ID
        if (res.data[0].length > 1000) this.itemsPerPage = 100
        this.fillReports(res.data[0], 0, 1000)
      }).catch(error => {
        this.$store.dispatch('showOverlay', { show: false })
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    setFirstAndLastDaysOfTheMonth () {
      const m = (new Date()).getMonth()
      const currentMonth = (m + 1).toString().padStart(2, 0)
      const currentYear = (new Date()).getFullYear()
      const nextYear = m <= 10 ? currentYear : currentYear + 1
      const nextMonth = m <= 10 ? (m + 2).toString().padStart(2, 0) : '01'
      const date1 = `2021-${currentMonth}-01`
      const date2 = new Date(+(new Date(`${nextYear}-${nextMonth}-01`)) - 86400000).toISOString().substring(0, 10)
      this.firstDayOfTheMonth = date1
      this.lastDayOfTheMonth = date2
    },
    clearProjectList () {
      this.selectAllProjects = false
      this.searchProject = ''
    },
    clearClientList () {
      this.selectAllClients = false
      this.searchClient = ''
    },
    clearEmployeeList () {
      this.selectAllEmployee = false
      this.searchEmployee = ''
    },
    clearDepartmentList () {
      this.selectAllDepartments = false
      this.searchDepartment = ''
    },
    async onColumnConfigSave (payload) {
      await this.saveTableColumnConfig(this.tableColumnConfigKey, payload)
    }
  }
}
</script>
<style lang="scss" scoped>
  .v-chip.v-size--default {
    height: 25px;
  }
  .c-general-reports::v-deep {
    .v-data-table__wrapper {
      height: calc(100vh - 320px);
    }
    .cursor-pointer {
      cursor: pointer;
    }
  }

  @media screen and (max-width: 599.5px) {
    .c-general-reports::v-deep {
      .v-data-table__wrapper {
        height: calc(100vh - 370px);
      }
    }
  }
</style>
